import React, { FunctionComponent } from 'react';
import ProductComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export type TListInlineItemProps = TParentComponentProps & {
  href?: string;
};

export const ListInlineLink: FunctionComponent<Partial<
  TListInlineItemProps
>> = ({ className, ...otherProps }) => {
  return <ProductComponent {...otherProps} />;
};
ListInlineLink.defaultProps = {
  as: 'a',
  defaultClassName: 'list-inline__link',
};

export default ListInlineLink;
